import { makeApiActionCreatorV3 } from '@actions/utils';

import * as api from '../api/contact';

const namespace = 'ASSESSMENT';

export const CONTACTS_FETCH_START = `${namespace}/CONTACTS_FETCH_START`;
export const CONTACTS_FETCH_SUCCESS = `${namespace}/CONTACTS_FETCH_SUCCESS`;
export const CONTACTS_FETCH_ERROR = `${namespace}/CONTACTS_FETCH_ERROR`;

export const CREATE_CONTACT_START = `${namespace}/CREATE_CONTACT_START`;
export const CREATE_CONTACT_SUCCESS = `${namespace}/CREATE_CONTACT_SUCCESS`;
export const CREATE_CONTACT_ERROR = `${namespace}/CREATE_CONTACT_ERROR`;

export const UPDATE_CONTACT_START = `${namespace}/UPDATE_CONTACT_START`;
export const UPDATE_CONTACT_SUCCESS = `${namespace}/UPDATE_CONTACT_SUCCESS`;
export const UPDATE_CONTACT_ERROR = `${namespace}/UPDATE_CONTACT_ERROR`;

export const DELETE_CONTACT_START = `${namespace}/DELETE_CONTACT_START`;
export const DELETE_CONTACT_SUCCESS = `${namespace}/DELETE_CONTACT_SUCCESS`;
export const DELETE_CONTACT_ERROR = `${namespace}/DELETE_CONTACT_ERROR`;

export const fetchContacts = makeApiActionCreatorV3(
  api.fetchContacts,
  CONTACTS_FETCH_START,
  CONTACTS_FETCH_SUCCESS,
  CONTACTS_FETCH_ERROR,
);

export const createContact = makeApiActionCreatorV3(
  api.createContact,
  CREATE_CONTACT_START,
  CREATE_CONTACT_SUCCESS,
  CREATE_CONTACT_ERROR,
);

export const updateContact = makeApiActionCreatorV3(
  api.updateContact,
  UPDATE_CONTACT_START,
  UPDATE_CONTACT_SUCCESS,
  UPDATE_CONTACT_ERROR,
);

export const deleteContact = makeApiActionCreatorV3(
  api.deleteContact,
  DELETE_CONTACT_START,
  DELETE_CONTACT_SUCCESS,
  DELETE_CONTACT_ERROR,
);
